import * as React from "react";
import { PieChart as RechartsPieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { Paper, Typography, Box, Stack } from "@mui/material";

export interface PieChartDataPoint {
  name: string;
  value: number;
}

interface Props {
  title?: string;
  data?: PieChartDataPoint[];
  headerActions?: React.ReactNode;
  children?: React.ReactNode;
}

const COLORS = [
  "#1976d2",
  "#388e3c",
  "#f57c00",
  "#d32f2f",
  "#7b1fa2",
  "#0097a7",
  "#c2185b",
  "#455a64",
  "#fbc02d",
  "#5d4037",
  "#00838f",
  "#e64a19",
  "#1565c0",
  "#2e7d32",
  "#ef6c00"
];

const ScrollableLegend: React.FC<any> = ({ payload }) => {
  return (
    <Box sx={{ maxHeight: 120, overflowY: "auto", mt: 1, display: "flex", justifyContent: "center" }}>
      <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 1, px: 1 }}>
        {(payload ?? []).map((entry: any, index: number) => (
          <Box key={`legend-${index}`} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: entry.color,
                flexShrink: 0
              }}
            />
            <Typography variant="caption" noWrap={false}>
              {entry.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const PieChart: React.FC<Props> = ({ title, data, headerActions, children }) => {
  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      {title && (
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Typography variant="h6">{title}</Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="row" spacing={2} alignItems="center">
            {headerActions}
          </Stack>
        </Box>
      )}
      {children ? (
        children
      ) : (
        <>
          <ResponsiveContainer width="100%" height={350}>
            <RechartsPieChart>
              <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={140} label={true}>
                {(data ?? []).map((_entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </RechartsPieChart>
          </ResponsiveContainer>
          <ScrollableLegend
            payload={(data ?? []).map((entry, index) => ({
              value: entry.name,
              color: COLORS[index % COLORS.length]
            }))}
          />
        </>
      )}
    </Paper>
  );
};

export { PieChart };
